import React from 'react'
import { connect } from 'react-redux'
import { Grid, Typography, Hidden } from '@material-ui/core'
// import Select from '../../Select'
import FromNumberSelect from '../../FromNumberSelect'

const SMS = ({ templateForm }) => (
  <Grid container spacing={8}>
    {/* <Grid item xs={12}>
      <Typography variant='h6'>
        Whom do you want to send this text message to?
      </Typography>
      <Select />
    </Grid> */}
    <Grid item xs={12}>
      <Typography variant="h6">
        What number do you want to send from?
      </Typography>
      <FromNumberSelect />
    </Grid>
    <Hidden smDown>
      <Grid item xs={12}>
        <Typography variant="h6">
          What message would you like to send
          {templateForm ? '' : ' to this(these) contact(s)'}?
        </Typography>
      </Grid>
    </Hidden>
  </Grid>
)

export default connect(
  state => ({
    automationTypeSelected: state.tasks.addOrEdit.automationTypeSelected,
  }),
  null,
)(SMS)
